import { HttpClient } from '@angular/common/http';
import { Component,OnInit } from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatFormField } from '@angular/material/form-field';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'settings-cmp',
    templateUrl: 'settings.component.html'
})

export class SettingsComponent implements OnInit {

    addOnBlurSettings = true;
    readonly separatorKeysCodesSettings = [ENTER, COMMA] as const;
    emailsSettings: any = [];

    constructor(private http: HttpClient, private matFormField: MatFormField, private router: Router) { }

    pass1:any;
    pass2:any;

    loading = false;
    success = false;
    error = false;

    settingsActiveTab: any = "alerts";

    allDevices: any = [];
    allRules: any = [];

    alertDevID: any = "-1";
    alertPhNbr: any = "";

    alertEmailsAddresses: any;

    currEmail: any = "";

    ngOnInit() {
        this.getDevices();
        this.currEmail = localStorage.getItem('username');
    }

    addSettings(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();
        // Add our fruit
        if (value) {
          this.emailsSettings.push(value);
        }
    
        // Clear the input value
        event.input.value = "";
    }
    
    removeSettings(email): void {
        const index = this.emailsSettings.indexOf(email);
    
        if (index >= 0) {
          this.emailsSettings.splice(index, 1);
        }
    }

    initStolenModal(){
        this.emailsSettings = [];
        this.emailsSettings.push(this.currEmail);
    }

    changePwd(){
        if(this.pass1 == this.pass2 && this.pass1 != null){
            console.log("pwd");

            this.loading = true;
            let body = {
                password: this.pass1
            }
            let headers = {'Authorization': 'Bearer ' + localStorage.getItem("accessToken")};
            this.http.post<any>('https://admin.iot-tracking.com/api/v2/auth/me', body, {headers}).subscribe((data) => {
                this.loading = false;
                if(Object.keys(data).length === 0){
                    this.success = true;
                }else{
                    this.error = false;
                }

            }, (error) => {
                this.loading = false;
                this.error = true;
            });

        }
    }

    toggleActive(currentActive){
        this.settingsActiveTab = currentActive;
    }

    getDevices(){
        this.loading = true;
        let headers = {'Authorization': 'Bearer ' + localStorage.getItem("accessToken")};
        this.http.get<any>('https://admin.iot-tracking.com/api/v2/groups/'+ localStorage.getItem("groupId") +'/devicesAll?searchTree=true&locale=fr', {headers}).subscribe((data) => {
            this.allDevices = data;
            this.loading = false;
            this.getRules();
        }, (error) => {
            if(error.status == 401){
                this.loading = false;
                //this.refreshToken();
                this.logout();
            }
            if(error.status == 500){
                this.loading = false;
            }
        });
    }

    getRules(){
        this.loading = true;
        let headers = {'Authorization': 'Bearer ' + localStorage.getItem("accessToken")};
        this.http.get<any>('https://admin.iot-tracking.com/api/v2/groups/'+ localStorage.getItem("groupId") +'?locale=fr', {headers}).subscribe((data) => {
            this.allRules = data.rules;
            for(var l = 0; l < this.allRules.length; l++){
                for(var g = 0; g < this.allDevices.length; g++){
                    if(this.allDevices[g].id == this.allRules[l].deviceIds[0]){
                        this.allRules[l].deviceName = this.allDevices[g].name;
                    }
                }
            }
            this.loading = false;
        }, (error) => {
            if(error.status == 401){
                this.loading = false;
                //this.refreshToken();
                this.logout();
            }
            if(error.status == 500){
                this.loading = false;
            }
        });
    }

    saveNewAlert(){
        if(this.alertDevID != "-1" && this.emailsSettings.length > 0){
            this.loading = true;
            let headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
            };
            let body = {
                rule: {
                    deviceIds: [this.alertDevID],
                    useDeviceTimezone: false,
                    forTree: false,
                    tagIds: [],
                    groupId: localStorage.getItem("groupId"),
                    name: this.alertDevID,
                    notifSubject: "{deviceName} ({deviceId}) notification",
                    notifMessage: "Your device {deviceName} has triggered a {action} at {time}.",
                    notifContacts: this.emailsSettings,
                    allDevices: false,
                    isActive: true,
                    timezone: "Europe/Paris",
                    timeLimit: {
                        from: "00:00",
                        to: "23:59",
                        mon: true,
                        tue: true,
                        wed: true,
                        thu: true,
                        fri: true,
                        sat: true,
                        sun: true
                    },
                    locale: "en",
                    notifChannel: "email",
                    deviceType: "simple_pack_plus_wifi_3_0_6_0",
                    rule: "{\"any\":[{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"position\"},{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"stopped_position\"},{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"moving_position\"},{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"start_of_movement_position\"}]}"
                
                }
            };
            this.http.post<any>('https://admin.iot-tracking.com/api/v2/groups/'+ localStorage.getItem("groupId") + '/rules?locale=fr', body ,{headers}).subscribe((data) => {
                this.loading = false;
                $('#createAlertModal').modal('hide');
                this.getRules();
            }, (error) => {
                this.loading = false;
                console.log(error);
            });
        }
        else{
            alert('Please select a device and fill in a phone number in the right format.');
        }
    }

    deleteAlert(ruleID){
        this.loading = true;
        let headers = {
            'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
        };
        this.http.delete<any>('https://admin.iot-tracking.com/api/v2/groups/'+localStorage.getItem("groupId")+'/rule/'+ruleID+'?locale=fr', {headers}).subscribe((data) => {
            this.loading = false;
            this.getRules();
        }, (error) => {
            this.loading = false;
            console.log(error);
        });
    }

    refreshToken(){
        this.loading = true;
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
        };
        let body = {
            refreshToken: localStorage.getItem("refreshToken")
        };
        this.http.post<any>('https://admin.iot-tracking.com/api/v2/auth/token/refresh', body ,{headers}).subscribe((data) => {
            this.loading = false;
            localStorage.accessToken = data.token.accessToken;
        }, (error) => {
            this.loading = false;
            console.log(error);
        });
    }

    logout(){
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
        };
        let body = {
            refreshToken: localStorage.getItem("refreshToken")
        };
        this.http.post<any>('https://app.iofrog.com/api/v2/auth/token/reject', body ,{headers}).subscribe((data) => {
            localStorage.clear();
            this.router.navigate(['login'], { queryParams: { logout: true } });
        }, (error) => {
            console.log(error);
        });
    }
}
